// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__iVwV2","assignButton":"CreateEditEquipmentSchedule_assignButton__16DnM"};